module.exports = __webpack_public_path__ + "static/media/score.cfebd402.svg";